import React from 'react';
import '../../styles/QuickRebookCard.css';

function formatSlotLabel(slot) {
  // slot = { date: "2026-06-15", time: "09:00", label: "غداً" }
  // The backend already provides a human-readable Arabic label.
  return `${slot.label} ${slot.time}`;
}

function QuickRebookCardSkeleton() {
  return (
    <div className="quick-rebook-skeleton" aria-hidden="true">
      <div className="quick-rebook-skeleton-line" style={{ width: '60%' }} />
      <div className="quick-rebook-skeleton-line" style={{ width: '35%' }} />
      <div className="quick-rebook-skeleton-line" style={{ width: '80%', marginTop: '0.75rem' }} />
    </div>
  );
}

function QuickRebookCard({
  lastBooking,
  slots,
  selectedSlot,
  loading,
  booking,
  onSelectSlot,
  onBook,
  onDismiss,
  onMoreTimes,
}) {
  if (loading) return <QuickRebookCardSkeleton />;

  return (
    <div className="quick-rebook-card" dir="rtl">
      <div className="quick-rebook-header">
        <p className="quick-rebook-title">
          ✂️ احجز مجدداً في {lastBooking.businessName}
        </p>
        <button
          type="button"
          className="quick-rebook-dismiss"
          onClick={onDismiss}
          aria-label="إغلاق"
        >
          ✕
        </button>
      </div>
      <p className="quick-rebook-subtitle">{lastBooking.reservationTypeName}</p>

      <p className="quick-rebook-slots-label">اختر موعداً:</p>
      <div className="quick-rebook-slots">
        {slots.map((slot) => {
          const key = `${slot.date}-${slot.time}`;
          const isSelected =
            selectedSlot &&
            selectedSlot.date === slot.date &&
            selectedSlot.time === slot.time;
          return (
            <button
              key={key}
              type="button"
              className={`quick-rebook-slot-btn${isSelected ? ' selected' : ''}`}
              onClick={() => onSelectSlot(slot)}
            >
              {formatSlotLabel(slot)}
            </button>
          );
        })}
      </div>

      <div className="quick-rebook-actions">
        <button
          type="button"
          className="quick-rebook-book-btn"
          onClick={onBook}
          disabled={!selectedSlot || booking}
        >
          {booking ? 'جاري الحجز...' : 'احجز الآن'}
        </button>
        <button
          type="button"
          className="quick-rebook-more-link"
          onClick={onMoreTimes}
        >
          المزيد من المواعيد ↗
        </button>
      </div>
    </div>
  );
}

export default QuickRebookCard;
